import { Button } from "../../../src/components/ui/button";
import { CardFooter } from "../../../src/components/ui/card";
import { useNavigate } from "react-router-dom";
import { cartItem } from "../products/productInterface";
import Coupons from "./coupons";
import { LoaderIcon } from "lucide-react";
import { WooCommerce } from "../../../src/lib/api";
import MyLoader from "../../../src/components/MyLoader";
import React from "react";
import { toast } from "../../../src/components/ui/use-toast";
import { ExclamationTriangleIcon } from "@radix-ui/react-icons";
import AramexRateCalculator from "../checkout/aramexRateCalculator";
import {
  createSession,
  createShipment,
} from "../../../src/lib/utils";
export default function CartDetails({
  checkout,
  order,
  loading,
  cart,
  item,
  saveInfo,
}: {
  checkout: boolean;
  order?: any;
  loading?: boolean;
  cart: any;
  item?: any;
  saveInfo?: boolean;
}) {
  const [loader, setLoader] = React.useState(false);
  const [rate, setRate] = React.useState("");
  const [discountCode, setDiscountCode] =
    React.useState("");
  const nav = useNavigate();
  const getDiscountCode = (e: string) => {
    setDiscountCode(e);
  };
  const saveInfoLocally = () => {
    localStorage.setItem(
      "firstName",
      order.billing.first_name
    );
    localStorage.setItem(
      "lastName",
      order.billing.last_name
    );
    localStorage.setItem("phone", order.billing.phone);
    localStorage.setItem("city", order.billing.city);
    localStorage.setItem("country", order.billing.country);
    localStorage.setItem(
      "address",
      order.billing.address_1
    );
    localStorage.setItem("email", order.billing.email);
    localStorage.setItem(
      "postalCode",
      order.billing.postalCode
    );
    localStorage.setItem("infoSaved", "true");
  };
  async function createOrder() {
    setLoader(true);
    if (
      order.billing.first_name === "" ||
      order.billing.last_name === "" ||
      order.billing.email === "" ||
      order.billing.phone === "" ||
      order.billing.country === "" ||
      order.billing.city === "" ||
      order.billing.postcode === ""
    ) {
      toast({
        title: "Required Fields",
        description: "Please fill your information",
        action: <ExclamationTriangleIcon />,
      });
      console.log(order);
      setLoader(false);
      return;
    }
    const orderWithShipping = {
      ...order,
      shipping_lines: [
        {
          method_id: "flat_rate",
          method_title: "Flat Rate",
          total: String(rate) || "4.7",
        },
      ],
    };
    const orderWithDiscount = {
      ...orderWithShipping,
      coupon_lines: [
        {
          code: discountCode, // The coupon code created earlier
        },
      ],
    };
    try {
      await WooCommerce.post(
        "orders",
        discountCode !== "0"
          ? orderWithDiscount
          : orderWithShipping
      )
        .then(async (response: any) => {
          const shipment = await createShipment(
            response.data,
            cart
          );
          order.payment_method !== "cash"
            ? await createSession(response.data)
            : nav(
                `/order/${response.data.id}/${shipment.ID}`
              );
          if (saveInfo === true) {
            saveInfoLocally();
          }
          setLoader(false);
        })
        .catch((error: any) => {
          setLoader(false);
          console.log(
            "error creating order",
            error.response.data
          );
          toast({
            title: "Error creating order, please try again",
            action: <ExclamationTriangleIcon />,
          });
        });
    } catch (err) {
      setLoader(false);
      console.log("error order", err);
    }
  }

  return loading ? (
    <MyLoader />
  ) : (
    <>
      <div
        className={`${
          checkout && "sticky right-0 top-40 "
        }  p-5 rounded-none flex flex-col justify-between h-full gap-10 border rounded-none shadow-2xl bg-white dark:bg-neutral-900 w-full`}
      >
        <h1 className="border-b pb-2 text-xl font-montserrat font-medium ">
          CART DETAILS
        </h1>
        <div className="flex flex-col gap-2 font-montserrat">
          {item &&
          typeof item === "object" &&
          !Array.isArray(item) ? (
            <div
              key={item?.product_id}
              className="flex gap-5 border-b text-sm justify-between items-center w-full"
            >
              <p className="w-12">1x</p>
              <p className="grow text-[12px] w-full">
                {item?.name?.toLocaleUpperCase()}
              </p>
              <p className="">
                {Number(item.price) || "0"}.00$
              </p>
            </div>
          ) : (
            <div className="flex flex-col gap-5 overflow-scroll no-scrollbar max-h-[200px]">
              {cart?.items?.map((item: cartItem) => (
                <div
                  key={item?.item_key}
                  className="flex gap-5 border-b text-sm justify-between items-center w-full"
                >
                  <p className="w-12">
                    {item?.quantity?.value} x
                  </p>
                  <p className="grow text-[12px] w-full">
                    {item?.title?.toLocaleUpperCase()}
                  </p>
                  <p className="">
                    {Number(item?.totals?.subtotal) / 100 ||
                      "0"}
                    .00$
                  </p>
                </div>
              ))}
            </div>
          )}
          <div className="border-b pb-2 flex gap-10 flex-col justify-between">
            <div className="flex justify-between mt-5">
              <p className="font-medium text-md">
                SUBTOTAL
              </p>
              {!item ? (
                <p className="font-medium">
                  {loading ? (
                    <LoaderIcon className="animate-spin w-4 h-4" />
                  ) : (
                    `${
                      cart?.totals?.subtotal / 100 || "0"
                    }.00$`
                  )}
                </p>
              ) : (
                <p className="font-medium">
                  {loading ? (
                    <LoaderIcon className="animate-spin w-4 h-4" />
                  ) : (
                    `${item?.price || "0"}.00$`
                  )}
                </p>
              )}
            </div>
            {checkout &&
            order?.payment_method !== "cashPickup" ? (
              order && order.billing.country !== "LB" ? (
                <AramexRateCalculator
                  paymentType={order?.payment_method}
                  city={order?.billing.city}
                  country={order?.billing.country}
                  weight={cart?.items_weight}
                  address={order?.billing.address_1}
                  pieces={cart?.item_count}
                  setRate={(e) => setRate(e)}
                  postCode={order.billing.postalCode}
                />
              ) : (
                <div className="flex justify-between items-center">
                  <div className="flex flex-col gap-1 justify-center items-start">
                    <span className="text-sm">
                      SHIPPING
                    </span>
                    <img
                      src="/aramex-logo.webp"
                      alt="aramex"
                      className="w-16 dark:bg-white"
                    />
                  </div>
                  <span>4.7$</span>
                </div>
              )
            ) : (
              <></>
            )}
            {checkout && (
              <Coupons
                total={
                  item
                    ? item.price
                    : Number(cart?.totals?.total) / 100
                }
                shippingRate={
                  order.payment_method !== "cashPickup"
                    ? order.billing.country !== "LB"
                      ? Number(rate)
                      : 4.7
                    : 0
                }
                returnDiscountCode={getDiscountCode}
              />
            )}
          </div>
        </div>
        <CardFooter className="flex justify-between p-0">
          {checkout && order ? (
            <Button
              className="w-full rounded-none"
              type="submit"
              onClick={() => createOrder()}
              disabled={!order}
            >
              {loader ? (
                <LoaderIcon className="animate-spin" />
              ) : (
                "ORDER NOW"
              )}
            </Button>
          ) : (
            <Button
              className="w-full rounded-none"
              type="submit"
              disabled={!cart}
              onClick={() => nav("/checkout")}
            >
              PROCEED TO CHECKOUT
            </Button>
          )}
        </CardFooter>
        {/* <MyMontySession order={order} />; */}
      </div>
    </>
  );
}
